import React from 'react';

const sizeClasses = {
  sm: 'px-4 py-2 text-small',
  md: 'px-6 py-3 text-body',
  lg: 'px-8 py-4 text-h4',
};

const variantClasses = {
  primary: 'bg-primary-500 text-white font-semibold hover:bg-primary-400 active:bg-primary-600 disabled:opacity-40',
  secondary: 'bg-transparent border border-primary-500 text-primary-500 font-semibold hover:bg-primary-50 active:bg-primary-100 disabled:opacity-40',
  ghost: 'bg-transparent text-primary-500 font-semibold hover:bg-primary-50 active:bg-primary-100 disabled:opacity-40',
};

function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  disabled = false,
  loading = false,
  type = 'button',
  className = '',
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        font-sans rounded-md transition-colors duration-fast
        focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        cursor-pointer disabled:cursor-not-allowed
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${loading ? 'opacity-75 cursor-not-allowed' : ''}
        ${className}
      `}
    >
      {loading ? (
        <span className="flex items-center justify-center gap-2">
          <svg className="w-4 h-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
          </svg>
          Loading…
        </span>
      ) : children}
    </button>
  );
}

export default Button;
